import { useContext } from "react";
import { AppContext } from "../App";
import bannerImage from "../assets/banner1.png";

const reasons = [
  "Clear service categories for easier procurement.",
  "Dependable sourcing with professional presentation.",
  "Responsive supply coordination for managed environments.",
];

export default function HomeAboutSection() {
  const appContext = useContext(AppContext);

  return (
    <section className="vex-section vex-section-light" data-aos="fade-up">
      <div className="container">
        <div className="row g-4 align-items-center">
          <div className="col-lg-6" data-aos="fade-right">
            <div className="vex-content-panel vex-content-panel-tall vex-home-about-panel">
              <p className="vex-panel-tag">About VEX</p>
              <h2>
                Practical supply categories for institutions, facilities, and
                teams.
              </h2>
              <p>
                VEX brings focused sourcing, dependable delivery, and clean
                category organization to clients who want a sharper corporate
                supply partner.
              </p>
              <div className="vex-reason-grid">
                {reasons.map((reason) => (
                  <div key={reason} className="vex-reason-line">
                    <p>{reason}</p>
                  </div>
                ))}
              </div>
              <button
                type="button"
                className="btn btn-outline-primary vex-btn"
                onClick={() => appContext.navTo({ item: "about_us" })}
              >
                Learn More
              </button>
            </div>
          </div>

          <div className="col-lg-6" data-aos="fade-left">
            <div className="vex-home-image-panel vex-home-image-panel-compact">
              <img src={bannerImage} alt="VEX operations" />
              <div className="vex-home-image-caption">
                <span>Reliable sourcing</span>
                <strong>
                  Professional supply support for modern operational needs.
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
